<template>
    <div>
        <MetadataForm
            ref="form"
            :polygon-id="polygonId"
            :pre-selected-date="preSelectedDate"
            :date-list="dateList"
            :pre-loaded-polygon-data="selectedPolygon"
            :other-metadata="other_metadata"
            @date-changed="currentDate = $event"
        />
    </div>
</template>

<script>
    import MetadataForm from "@/components/metadataModal/MetadataForm.vue";
    import MetadataInfo from "@/components/metadataModal/MetadataInfo";

    export default {
        name: "ContinueMetadataModal",

        components: {
            MetadataForm,
            MetadataInfo,
        },

        props: {
            polygonId: {
                type: Number,
                required: true
            },

            selectedDates: {
                type: Array,
                required: true,
                default: () => []
            },

            selectedPolygon: {
                type: Object,
                required: true,
                default: () => ({})
            }
        },

        created() {
            console.log('🟡 ContinueMetadataModal CREATED');
            this.dateList = this.selectedDates;
            this.preSelectedDate = this.dateList[0];
        },

        computed: {
            other_metadata() {
                return {
                    user_name: this.selectedPolygon.user.name,
                    river_name: this.selectedPolygon.river.name,
                    created_at: this.selectedPolygon.images?.[0]?.created_at || null,
                    polygon_name: this.selectedPolygon.name,
                    polygon_notes: this.selectedPolygon.notes
                }
            }
        },

        data() {
            return {
                preSelectedDate: "",
                currentDate: null,
                dateList: []
            };
        },

        beforeDestroy() {
            console.log('🟡 ContinueMetadataModal beforeDestroy - stopping polling');
            if (this.$refs.form && this.$refs.form.stopStatusPolling) {
                this.$refs.form.stopStatusPolling();
            }
        }
    };
</script>